var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarrotwithviewbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 210 297",
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.413002px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M -1.8853035,251.12847 C 110.27801,79.737743 110.27801,79.737743 110.27801,79.737743 l 47.93306,31.954207 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.413002px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 129.45125,91.357443 12.46259,-47.20507 16.29723,7.988552 z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.413002px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 129.45125,91.357443 57.51964,-37.037824 10.54527,12.345945 z",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "4.95px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M -1.8853035,251.12847 158.21107,111.69195",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "4.95px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 158.21107,111.69195 110.27801,79.737743 -1.8853035,251.12847",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "4.95px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 129.45125,91.357443 12.46259,-47.20507",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "4.95px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 141.91384,44.152373 16.29723,7.988551 -28.75982,39.216519 57.51964,-37.037824 10.54527,12.345945 -68.06491,24.691879",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "4.95px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 78.482143,130.82142 14.142858,11.04911",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "4.95px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 55.941966,180.32142 15.026784,9.28125",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff6600",
      strokeWidth: 0.126269
    },
    d: "m 11.396038,47.29456 c 0,-0.0992 12.859422,-19.763249 13.06629,-19.98038 0.1341,-0.140753 0.37163,-0.0058 1.388548,0.789182 0.674726,0.527439 1.274016,0.958981 1.331755,0.958981 0.126621,0 0.628386,-0.619915 0.628386,-0.776352 0,-0.06102 -0.58771,-0.572999 -1.306023,-1.137727 l -1.306021,-1.026777 2.897951,-4.432651 c 1.593874,-2.437958 2.964044,-4.502818 3.044822,-4.588578 0.114757,-0.121833 1.057377,0.451002 4.311073,2.619856 2.290313,1.526681 4.181015,2.826218 4.201563,2.88786 0.03037,0.09112 -15.901222,14.084478 -16.661071,14.634092 -0.193037,0.139628 -0.379659,0.06502 -1.370532,-0.547908 -0.630886,-0.390251 -1.21546,-0.682403 -1.299053,-0.649227 -0.08359,0.03318 -0.251423,0.231679 -0.372956,0.441116 l -0.220967,0.380796 1.077001,0.681908 1.077001,0.681907 -5.243884,4.569054 c -2.884136,2.51298 -5.243883,4.535662 -5.243883,4.494848 z",
    id: "path45",
    transform: "matrix(4.95,0,0,4.95,-43.5,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ff00",
      strokeWidth: 0.126269
    },
    d: "m 36.394074,15.356183 c -0.0018,-0.06617 0.318292,-1.349485 0.711274,-2.851818 l 0.714514,-2.7315148 0.961791,0.4380478 c 0.528985,0.240926 0.98556,0.461628 1.014612,0.490449 0.05932,0.05884 -0.239216,0.487059 -2.100743,3.013338 -0.714015,0.96899 -1.299667,1.707664 -1.301448,1.641498 z",
    id: "path47",
    transform: "matrix(4.95,0,0,4.95,-43.5,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ff00",
      strokeWidth: 0.126269
    },
    d: "m 40.128564,15.82289 c 0.06598,-0.05911 1.511259,-1.002727 3.211741,-2.096929 l 3.091786,-1.989459 0.652558,0.735455 0.652557,0.735455 -3.744343,1.357964 c -3.687303,1.337277 -4.105072,1.473226 -3.864299,1.257514 z",
    id: "path49",
    transform: "matrix(4.95,0,0,4.95,-43.5,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrotwithviewbox);
export default __webpack_public_path__ + "static/media/carrot with viewbox.00b5d62045422d18f309e349f07e7389.svg";
export { ForwardRef as ReactComponent };